export const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function handleKeyDownOnlyNumeric(event: any) {
  const checkChars = ['e', 'E', '.', '-', '+'];
  if (checkChars.includes(event.key)) {
    event.preventDefault();
  }
}
